import * as Highcharts from 'highcharts';
import { chartColors } from '@shared/colors/data/palette/charts-colors.data';

interface HighchartsLegendOptions extends Highcharts.LegendOptions {
    adjustChartSize?: boolean;
}

interface HighchartsOptions extends Highcharts.Options {
    legend?: HighchartsLegendOptions;
}

export const options: Record<string, HighchartsOptions> = {
    generic: {
        chart: {
            type: 'pie',
            backgroundColor: 'transparent',
        },
        credits: { enabled: false },
        legend: {
            itemStyle: {
                fontSize: '6px',
                fontWeight: 'normal',
            },
            /* 'hiding' origin symbols */
            symbolHeight: 1,
            symbolWidth: 1,
            useHTML: true,
        },
        plotOptions: {
            pie: {
                colors: chartColors,
                borderWidth: 0,
                dataLabels: {
                    enabled: false,
                },
                showInLegend: true,
                allowPointSelect: false,
                point: {
                    events: {
                        legendItemClick: (e) => {
                            e.preventDefault();
                        },
                    },
                },
                states: {
                    hover: {
                        brightness: 0,
                    },
                },
            },
            series: {
                states: {
                    hover: {
                        halo: {
                            opacity: 1,
                        },
                    },
                },
            },
        },
        series: [
            // outer shadow series
            {
                opacity: 0.3,
                enableMouseTracking: false,
                showInLegend: false,
                type: 'pie',
            },
            // data series
            {
                name: 'Value',
                states: {
                    inactive: {
                        opacity: 0,
                    },
                },
                type: 'pie',
            },
        ],
        title: {
            text: '',
            align: 'left',
            floating: true,
            useHTML: true,
        },
        tooltip: {
            enabled: false,
        },
    },

    small: {
        chart: {
            height: 120,
            spacingRight: 0,
        },
        legend: {
            width: '60%',
            align: 'right',
            itemMarginTop: 0,
            itemMarginBottom: 0,
            padding: 0,
            layout: 'vertical',
            verticalAlign: 'middle',
            adjustChartSize: true,
            navigation: {
                enabled: false,
            },
            labelFormatter(this: Highcharts.Point): string {
                const value = this.percentage.toFixed(2);

                return `
                    <div class="piechart-legend-item small">
                        <div class="colored-circle-box s-10">
                            <span style="background-color: ${this.color}"></span>
                        </div>
                        <span class="item-title">
                            ${this.name}
                        </span>
                        <span class="item-value">
                            ${value}%
                        </span>
                    </div>
                `;
            },
            y: 0,
        },
        plotOptions: {
            pie: {
                center: ['50%', '50%'],
            },
        },
        series: [
            // outer shadow series
            {
                size: 115,
                innerSize: 75,
                type: 'pie',
            },
            // data series
            {
                size: 95,
                innerSize: 75,
                type: 'pie',
            },
        ],
        title: {
            x: 40,
            verticalAlign: 'middle',
        },
    },

    big: {
        chart: {
            width: 390,
            height: 240,
            margin: 0,
        },
        legend: {
            enabled: false,
        },
        plotOptions: {
            pie: {
                center: ['50%', '47%'],
            },
        },
        series: [
            // outer shadow series
            {
                size: 203,
                innerSize: 143,
                type: 'pie',
            },
            // data series
            {
                size: 177,
                innerSize: 143,
                states: {
                    hover: {
                        halo: {
                            size: 13,
                        },
                    },
                },
                type: 'pie',
            },
        ],
        title: {
            x: 119,
            y: 95,
        },
    },
};
